import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

import SliderCard from "../../../components/landing/TopHeader/card";
import CardShimmer from "../../../components/landing/TopHeader/card-shimmer";

import "swiper/css/bundle";
import "swiper/css";

const Index = () => {
  const movieState = useSelector((state) => state.movieState);
  let slider = movieState?.movie?.data?.slice(0, 4);
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
        <div className="lg:col-span-1 mb-10 lg:mb-0">
          <div className="mb-6 lg:mb-10">
            <span className="px-4 py-2 text-xs lg:text-base bg-sky-500 rounded-full text-white leading-normal">
              Together
            </span>
            <h1 className="relative hidden lg:block text-3xl lg:text-6xl font-bold text-slate-700 leading-snug mb-2">
              Watch Your <br />{" "}
              <span className="relative">
                <span className="relative z-10">Favorate</span>
                <svg
                  className="absolute -bottom-5 lg:-bottom-5 left-0 w-full h-12 z-0 !fill-green-300"
                  width="613"
                  height="116"
                  viewBox="0 0 613 116"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M227.146 45.5068C223.415 46.3061 219.706 47.1547 216.019 48.0563C214.676 48.384 213.856 49.738 214.182 51.0788L214.2 51.1316C194.23 51.4772 174.264 52.0134 154.308 52.7454C125.481 53.8038 96.47 55.5465 67.7408 58.2544C39.3496 60.9303 31.5059 61.6185 7.07943 66.0943C6.38088 66.2222 5.0333 66.2142 4.30831 66.417C3.61888 66.6096 3.12536 66.9453 2.80844 67.2739C2.40248 67.6904 2.169 68.1701 2.07009 68.6951C1.96544 69.2672 1.99661 69.9663 2.48734 70.7471C3.87173 72.9388 6.10977 73.5405 8.8394 73.0783C11.188 72.6803 14.0274 71.27 16.2522 71.1088C53.2886 68.4296 90.2999 65.4588 127.34 62.8333C184.045 58.8143 240.577 56.9184 297.119 55.784C356.562 56.303 415.975 58.4515 475.287 62.1041C513.915 64.4813 552.462 68.0119 591.04 71.1003C591.011 71.2701 591.006 71.4474 591.014 71.6283C591.098 73.0058 592.288 74.0555 593.666 73.9716C595.061 73.8864 607.514 73.5309 609.81 72.9647C611.125 72.6403 611.639 71.8282 611.81 71.4805C612.273 70.5269 612.299 69.4908 611.268 68.5024C611.064 68.3128 610.684 67.9995 609.984 67.7995C609.387 67.6241 607.906 67.4024 605.216 67.1983C562.008 63.8843 518.853 59.7773 475.596 57.1109C456.284 55.9244 436.961 54.8929 417.622 54.0304C443.87 53.6871 470.127 53.2978 496.427 52.7286C497.56 52.7074 498.109 52.5233 498.21 52.4799C499.654 51.8561 499.754 50.715 499.727 50.0683C499.72 49.8375 499.526 47.9325 497.407 47.6652C496.166 47.5081 487.209 47.2033 483.763 47.0209C467.202 46.1295 467.589 46.27 450.647 45.5008C413.392 43.8142 376.192 42.694 338.892 41.7894C324.021 41.4293 309.15 41.14 294.275 40.9284C337.144 37.2734 380.898 37.4176 422.596 36.9635C444.107 36.7297 465.623 36.6298 487.133 36.905C496.767 37.0285 506.399 37.3136 516.032 37.4853C519.025 37.5383 522.009 37.6614 524.998 37.7323C525.353 37.7403 529.991 37.778 530.752 37.7613C532.745 37.7178 533.204 35.943 533.222 35.8719C533.307 35.5379 533.637 33.15 531.161 32.7818C495.396 27.4618 457.9 28.7135 421.774 27.8505C358.546 26.3399 295.148 26.6738 231.921 28.6453C203.956 29.5171 176.08 31.3323 148.153 33.1384C134.206 34.0405 120.221 34.9965 106.406 37.1966C105.02 37.4176 101.879 37.645 100.356 37.907C99.5806 38.0409 99.0285 38.2518 98.7756 38.3958C97.6678 39.0209 97.447 39.94 97.4292 40.5845C97.418 41.0674 97.5203 42.768 99.8023 43.2873C132.411 50.7168 168.599 45.9263 201.714 45.6412C210.191 45.5682 218.665 45.5239 227.146 45.5068ZM254.759 45.5477C244.936 47.05 235.21 48.8335 225.622 50.9557C249.462 50.63 273.304 50.5755 297.155 50.7843C336.502 49.9949 375.848 49.573 415.243 49.0606C389.771 48.1269 364.292 47.407 338.77 46.7885C310.776 46.1096 282.769 45.6839 254.759 45.5477ZM391.097 32.2626C338.1 31.4905 285.029 31.9915 232.08 33.6426C204.164 34.5131 176.347 36.3255 148.475 38.1282C137.507 38.8375 126.51 39.5766 115.598 40.9447C143.789 44.4133 173.83 40.8808 201.673 40.6415C219.257 40.4902 236.849 40.4608 254.437 40.5456C299.156 33.7559 345.871 32.7257 391.097 32.2626Z"
                  />
                </svg>
              </span>{" "}
              Movie <br /> with Your Partner{" "}
              <div className="flex absolute -space-x-5 bottom-0 right-0">
                <img
                  className="h-14 w-14 rounded-full border-4 border-white"
                  src="https://cdn.dribbble.com/users/4189231/avatars/small/beac5382e2629adcd8f3bdfa68994fe5.jpg?1570110577"
                  alt=""
                />
                <img
                  className="h-14 w-14 rounded-full border-4 border-white"
                  src="https://cdn.dribbble.com/users/2378116/avatars/normal/194fc299c5499185a3430c42ae0eb3e4.jpg?1621141048"
                  alt=""
                />
              </div>
            </h1>
            <h1 className="block lg:hidden text-3xl lg:text-6xl font-bold text-slate-700 leading-snug mb-2">
              Watch Your{" "}
              <span className="relative">
                <span className="relative z-10">Favorate</span>
                <svg
                  className="absolute -bottom-5 lg:-bottom-5 left-0 w-full h-12 z-0 !fill-green-300"
                  width="613"
                  height="116"
                  viewBox="0 0 613 116"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M227.146 45.5068C223.415 46.3061 219.706 47.1547 216.019 48.0563C214.676 48.384 213.856 49.738 214.182 51.0788L214.2 51.1316C194.23 51.4772 174.264 52.0134 154.308 52.7454C125.481 53.8038 96.47 55.5465 67.7408 58.2544C39.3496 60.9303 31.5059 61.6185 7.07943 66.0943C6.38088 66.2222 5.0333 66.2142 4.30831 66.417C3.61888 66.6096 3.12536 66.9453 2.80844 67.2739C2.40248 67.6904 2.169 68.1701 2.07009 68.6951C1.96544 69.2672 1.99661 69.9663 2.48734 70.7471C3.87173 72.9388 6.10977 73.5405 8.8394 73.0783C11.188 72.6803 14.0274 71.27 16.2522 71.1088C53.2886 68.4296 90.2999 65.4588 127.34 62.8333C184.045 58.8143 240.577 56.9184 297.119 55.784C356.562 56.303 415.975 58.4515 475.287 62.1041C513.915 64.4813 552.462 68.0119 591.04 71.1003C591.011 71.2701 591.006 71.4474 591.014 71.6283C591.098 73.0058 592.288 74.0555 593.666 73.9716C595.061 73.8864 607.514 73.5309 609.81 72.9647C611.125 72.6403 611.639 71.8282 611.81 71.4805C612.273 70.5269 612.299 69.4908 611.268 68.5024C611.064 68.3128 610.684 67.9995 609.984 67.7995C609.387 67.6241 607.906 67.4024 605.216 67.1983C562.008 63.8843 518.853 59.7773 475.596 57.1109C456.284 55.9244 436.961 54.8929 417.622 54.0304C443.87 53.6871 470.127 53.2978 496.427 52.7286C497.56 52.7074 498.109 52.5233 498.21 52.4799C499.654 51.8561 499.754 50.715 499.727 50.0683C499.72 49.8375 499.526 47.9325 497.407 47.6652C496.166 47.5081 487.209 47.2033 483.763 47.0209C467.202 46.1295 467.589 46.27 450.647 45.5008C413.392 43.8142 376.192 42.694 338.892 41.7894C324.021 41.4293 309.15 41.14 294.275 40.9284C337.144 37.2734 380.898 37.4176 422.596 36.9635C444.107 36.7297 465.623 36.6298 487.133 36.905C496.767 37.0285 506.399 37.3136 516.032 37.4853C519.025 37.5383 522.009 37.6614 524.998 37.7323C525.353 37.7403 529.991 37.778 530.752 37.7613C532.745 37.7178 533.204 35.943 533.222 35.8719C533.307 35.5379 533.637 33.15 531.161 32.7818C495.396 27.4618 457.9 28.7135 421.774 27.8505C358.546 26.3399 295.148 26.6738 231.921 28.6453C203.956 29.5171 176.08 31.3323 148.153 33.1384C134.206 34.0405 120.221 34.9965 106.406 37.1966C105.02 37.4176 101.879 37.645 100.356 37.907C99.5806 38.0409 99.0285 38.2518 98.7756 38.3958C97.6678 39.0209 97.447 39.94 97.4292 40.5845C97.418 41.0674 97.5203 42.768 99.8023 43.2873C132.411 50.7168 168.599 45.9263 201.714 45.6412C210.191 45.5682 218.665 45.5239 227.146 45.5068ZM254.759 45.5477C244.936 47.05 235.21 48.8335 225.622 50.9557C249.462 50.63 273.304 50.5755 297.155 50.7843C336.502 49.9949 375.848 49.573 415.243 49.0606C389.771 48.1269 364.292 47.407 338.77 46.7885C310.776 46.1096 282.769 45.6839 254.759 45.5477ZM391.097 32.2626C338.1 31.4905 285.029 31.9915 232.08 33.6426C204.164 34.5131 176.347 36.3255 148.475 38.1282C137.507 38.8375 126.51 39.5766 115.598 40.9447C143.789 44.4133 173.83 40.8808 201.673 40.6415C219.257 40.4902 236.849 40.4608 254.437 40.5456C299.156 33.7559 345.871 32.7257 391.097 32.2626Z"
                  />
                </svg>
              </span>{" "}
              Movie with Your Partner
            </h1>
            <p className="xl:w-[450px] text-base lg:text-lg font-normal text-slate-500 leading-normal">
              The easiest way to watch your favourite movie with your partner,
              friend. fomily and your beloved one. Together is better than
              lonely
            </p>
          </div>
          <div className="flex space-x-4">
            <Link
              to="/"
              className="flex items-center justify-center w-full md:w-fit py-4 px-8 bg-sky-500 text-white rounded-xl transition-all duration-300 ease-in-out hover:bg-sky-600"
            >
              Learn More
            </Link>
            <Link
              to="/"
              className="flex items-center justify-center w-full md:w-fit py-4 px-8 text-sky-500 rounded-xl transition-all duration-300 ease-in-out hover:bg-sky-600/5"
            >
              About us
            </Link>
          </div>
        </div>
        <div className="-order-1 lg:order-1 mb-10">
          <Swiper
            className="lg:w-[500px]"
            spaceBetween={24}
            slidesPerView={3}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            breakpoints={{
              // when window width is >= 320px
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              // when window width is >= 480px
              480: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
              // when window width is >= 640px
              640: {
                slidesPerView: 1,
                spaceBetween: 21,
              },
              // when window width is >= 768px
              768: {
                slidesPerView: 2,
                spaceBetween: 21,
              },
              // when window width is >= 1024px
              1024: {
                slidesPerView: 1,
                spaceBetween: 21,
              },
              // when window width is >= 1440px
              1440: {
                slidesPerView: 1,
                spaceBetween: 21,
              },
            }}
          >
            {movieState.loading ? (
              <CardShimmer />
            ) : movieState.error ? (
              <CardShimmer />
            ) : (
              movieState.movie.data &&
              slider.map((movie) => (
                <SwiperSlide key={movie.id}>
                  <SliderCard data={movie} />
                </SwiperSlide>
              ))
            )}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Index;
